// extracted by mini-css-extract-plugin
export default {"custom-button":"Button_custom-button__IF9p0"};